import Bundle from "@framework/Bundle";

export const routes = require.context(
	"./",
	true,
	/.*\/@module($|\/routes\.(js))/
);

/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-START */
/* webpack-strip-block:removed */
export const libs = [];
export const styles = [{value: () => import(/* webpackPreload: true */ "./@styles/Info.styles.js"), path: "./@styles/Info.styles.js"}];
export const constants = [{value: () => import(/* webpackPreload: true */ "./@constants/tutors/NearMeBannerViewModel.json"), path: "./@constants/tutors/NearMeBannerViewModel.json"}];
export const loadable = require.context("./", true, /\.(loadable)\.(js)$/);
export const stores = [{value: () => import(/* webpackPreload: true */ "./@stores/NearMe.store.js"), path: "./@stores/NearMe.store.js"}];
export const extensions = [{value: () => import(/* webpackPreload: true */ "./@.extension.js"), path: "./@.extension.js"}];
export const background = require.context("./", true, /\.(background)\.(js)$/);
/* webpack-strip-block:removed */
/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-END */
